



















import { Component, Mixins } from 'vue-property-decorator'

import FieldWrapper from '../../components/FieldWrapper.vue'
import { InputFieldEmits, InputFieldSettings } from '../../mixins'
import { PasswordInputProps } from "./types";

@Component({
  components: {
    FieldWrapper,
  },
})
export default class PasswordInput extends Mixins<InputFieldSettings<PasswordInputProps>, InputFieldEmits>(InputFieldSettings, InputFieldEmits) {
  get autocomplete() {
    return this.inputSettings?.autocomplete ?? 'new-password'
  }
}
